import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import * as AdminModels from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { AdminUserSessionContext } from '../../../viewmodels/AdminViewModels';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'admin/AutomationTemplate/industry';

export function useIndustryAutomationTemplatesQuery({
	enabled = true,
	industry,
}: {
	enabled?: boolean;
	industry: Api.Industry;
}) {
	const userSession = useUserSession<AdminUserSessionContext>();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<AdminModels.ISystemAutomationTemplate[]>(
				`admin/AutomationTemplate/industry/${industry}`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, industry],
	});
}

export const invalidateIndustryAutomationTemplatesQuery = (industry: Api.Industry) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, industry] });
};

export const invalidateAllIndustryAutomationTemplatesQueries = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
